import CurrencyFormat from "react-currency-format";
import { replaceLeanWithBuilding } from "../../../redux/reducers/utils";
import { PriceDisplay } from "./Summary";

export const ComponentSummary = ({ summaryViewData, params, const_var, manufacturerDoorName, showPriceDetail }) => {
	return (
		<div className="highlight-with-bg">
			{summaryViewData != undefined && summaryViewData.entry_points != undefined
				? Object.entries(summaryViewData.entry_points).map(([key, value]) => {
						const rename_garage_door = value.entry_doorNewType && value.entry_doorNewType == "Custom Size" ? (showPriceDetail == false ? "Custom Garage Door" : "Garage Door") : "Garage Door";
						const rename_garage_door_frameout =
							value.entry_doorNewType && value.entry_doorNewType == "Custom Size"
								? showPriceDetail == false
									? summaryViewData?.manufacturer == 148 || summaryViewData?.manufacturer == 121 || summaryViewData?.manufacturer == 8 || summaryViewData?.manufacturer == 181
										? "Custom Frameout"
										: "Custom Garage Frameout"
									: summaryViewData?.manufacturer == 148 || summaryViewData?.manufacturer == 121 || summaryViewData?.manufacturer == 8 || summaryViewData?.manufacturer == 181
										? "Frameout"
										: "Garage Frameout"
								: summaryViewData?.manufacturer == 148 || summaryViewData?.manufacturer == 121 || summaryViewData?.manufacturer == 8 || summaryViewData?.manufacturer == 181
									? "Frameout"
									: "Garage Frameout";
						const rename_walk_in_door = value.entry_doorNewType && value.entry_doorNewType == "Custom Size" ? (showPriceDetail == false ? "Custom Walk-in Door" : "Walk-in Door") : "Walk-in Door";
						const rename_walk_in_door_frameout =
							value.entry_doorNewType && value.entry_doorNewType == "Custom Size" ? (showPriceDetail == false ? "Custom Walk-in Frameout" : "Walk-in Frameout") : "Walk-in Frameout";
						const rename_window = value.entry_doorNewType && value.entry_doorNewType == "Custom Size" ? (showPriceDetail == false ? "Custom Window" : "Window") : "Window";
						const rename_window_frameout = value.entry_doorNewType && value.entry_doorNewType == "Custom Size" ? (showPriceDetail == false ? "Custom Window Frameout" : "Window Frameout") : "Window Frameout";

						let cName = {
							garage_door: rename_garage_door,
							garage_door_frameout: rename_garage_door_frameout,
							walkin: rename_walk_in_door,
							walk_in_door: rename_walk_in_door,
							walkin_frameout: rename_walk_in_door_frameout,
							window: rename_window,
							window_frameout: rename_window_frameout
						};
						let entryLocation = value.entry_location;
						if (const_var.isLTBuilding) {
							if (value.entry_location === "rlrside") {
								entryLocation = "rlrside2";
							}
							if (value.entry_location === "lllside") {
								entryLocation = "lllside2";
							}
							if (value.entry_location === "flulside") {
								entryLocation = "flulside2";
							}
						}

						const wallName = replaceLeanWithBuilding(const_var.updated_entry_wall_location[entryLocation], true);
						const isWalkinOrWindow = value.entry_type.includes("walkin") || value.entry_type.includes("window");
						const isFrameout = value.entry_type.includes("_frameout");
						const isGarageDoorFrameout = value.entry_type.includes("garage_door_frameout");
						const sizeLabel = isWalkinOrWindow ? "Inch" : "Feet";
						const frameoutLabel = isFrameout
							? manufacturerDoorName === "Frameout"
								? cName[value.entry_type]
								: `${cName[value.entry_type]} (${manufacturerDoorName && isGarageDoorFrameout ? manufacturerDoorName : value.nested_array_key})`
							: `${cName[value.entry_type]} (${value.nested_array_key})`;

						const wallLabel = params.isBreezeway ? (value.entry_location === "fend" ? "Front Storage Front" : value.entry_location === "bend" ? "Back Storage Back" : wallName) : wallName;
						return (
							<div key={key} className="summary-row repeat-loop">
								{value.is_breezeway_frameout === false && (
									<>
										<div className="summary-info">
											<aside className="summary-info-left">
												{value.name.replace("_", " ")} {sizeLabel} &nbsp;
												{frameoutLabel}
												&nbsp; | &nbsp;
												{wallLabel} Wall
											</aside>
											<aside className="summary-info-right">{value?.entry_price != null && value?.entry_price != undefined && <PriceDisplay value={String(value.entry_price)} />}</aside>
										</div>
										{summaryViewData?.manufacturer == 9 && value.parent_array_key == "Walk" && value.threshold == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Threshold</aside>
												<aside className="summary-info-right">
													{value?.threshold_price != null && value?.threshold_price != undefined && <PriceDisplay value={String(value?.threshold_price)} />}
												</aside>
											</div>
										) : null}
										{value.entry_overhead_type_name != undefined && value.child_array_key == "overhead_door_door" ? (
											<div className="summary-info">
												<aside className="summary-info-left">{value.entry_overhead_type_name}</aside>
												<aside className="summary-info-right">
													{value?.entry_overhead_type_price != null && value?.entry_overhead_type_price != undefined && <PriceDisplay value={String(value?.entry_overhead_type_price)} />}
												</aside>
											</div>
										) : null}
										{value.entry_trim_kit == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">45 Degree Trimkit</aside>
												<aside className="summary-info-right">
													{value?.entry_trim_kit_price != null && value?.entry_trim_kit_price != undefined && <PriceDisplay value={String(value?.entry_trim_kit_price)} />}
												</aside>
											</div>
										) : null}
										{value.entry_header_seal == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Header Seal</aside>
												<aside className="summary-info-right">
													{value?.entry_header_seal_price != null && value?.entry_header_seal_price != undefined && <PriceDisplay value={String(value?.entry_header_seal_price)} />}
												</aside>
											</div>
										) : null}
										{value.entry_chain_hoist == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Chain hoist</aside>
												<aside className="summary-info-right">
													{value?.entry_chain_hoist_price != null && value?.entry_chain_hoist_price != undefined && <PriceDisplay value={String(value?.entry_chain_hoist_price)} />}
												</aside>
											</div>
										) : null}
										{value.entry_certified == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Certified</aside>
												<aside className="summary-info-right">$0.00</aside>
											</div>
										) : null}
										{value.entry_automatic_openers == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Automatic Openers</aside>
												<aside className="summary-info-right">
													{value?.entry_automatic_openers_price != undefined && value?.entry_automatic_openers_price != null && (
														<PriceDisplay value={String(value?.entry_automatic_openers_price)} />
													)}
												</aside>
											</div>
										) : null}
										{value.installation_is_end_wall != undefined && value.installation_is_end_wall != "no" && value.installation_is_end_wall != "" ? (
											<div className="summary-info">
												<aside className="summary-info-left">End Installation Fee</aside>
												<aside className="summary-info-right">
													{value?.installation_end_wall_fee != undefined && value?.installation_end_wall_fee != null && <PriceDisplay value={String(value?.installation_end_wall_fee)} />}
												</aside>
											</div>
										) : null}
										{value.installation_is_side_wall != undefined && value.installation_is_side_wall != "no" && value.installation_is_side_wall != "" ? (
											<div className="summary-info">
												<aside className="summary-info-left">Side Installation Fee</aside>
												<aside className="summary-info-right">
													{value?.installation_side_wall_fee != undefined && value?.installation_side_wall_fee != null && <PriceDisplay value={String(value?.installation_side_wall_fee)} />}
												</aside>
											</div>
										) : null}
										{value.entry_garageDoor_color_Obj != undefined && value.entry_type == "garage_door" ? (
											<div className="summary-info">
												<aside className="summary-info-left">{`Garage Door Color (${value.entry_garageDoor_color_Obj?.name})`}</aside>
												<aside className="summary-info-right">
													{value?.entry_garageDoor_color_price != undefined && value?.entry_garageDoor_color_price != null && (
														<PriceDisplay value={String(value?.entry_garageDoor_color_price)} />
													)}
												</aside>
											</div>
										) : null}

										{value.entry_insulated == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Insulated</aside>
												<aside className="summary-info-right">
													{value?.entry_insulated_price != undefined && value?.entry_insulated_price != null && <PriceDisplay value={String(value?.entry_insulated_price)} />}
												</aside>
											</div>
										) : null}

										{value.entry_motor == true ? (
											<div className="summary-info">
												<aside className="summary-info-left">Motors : {value.entry_motor_name}</aside>
												<aside className="summary-info-right">
													{value?.entry_motor_price != null && value?.entry_motor_price != undefined && <PriceDisplay value={String(value?.entry_motor_price)} />}
												</aside>
											</div>
										) : null}

										{Object.keys(value).map((e) => {
											if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
												let name = e.replace("entry_", "").replace("_add_on_options", "").split("_").join(" ");
												name = name ? name[0].toUpperCase() + name.slice(1) : "";
												return value[e] == true ? (
													<div className="summary-info">
														<aside className="summary-info-left">Add On: {name}</aside>
														<aside className="summary-info-right">
															<PriceDisplay value={String(e + "_price")} />
														</aside>
													</div>
												) : null;
											}
										})}
									</>
								)}
							</div>
						);
					})
				: null}
		</div>
	);
};

export const CupolaSummary = ({ summaryViewData, cupolaEntries, const_var }) => {
	return (
		<>
			{summaryViewData && const_var?.post_data?.building?.cupolaEntries?.length > 0 && cupolaEntries && (
				<div>
					<div className="section-title-wrapper ">
						<h6 className="section-title mb-0">Cupola</h6>
					</div>
					<div className="highlight-with-bg">
						{cupolaEntries.length > 0 ? (
							<>
								{cupolaEntries
									.sort((a, b) => a.dimension.split("x")[0] - b.dimension.split("x")[0])
									.map((cupola) => (
										<div className="summary-row d-flex justify-content-between repeat-loop" key={cupola.key}>
											<div className="summary-label">
												<span className="summary-label-title">{cupola.cupolaName}</span>
												{" - "}
												<span className="dark-span">{cupola.dimension} ' </span> &nbsp;&nbsp; | &nbsp;&nbsp; Qty: {cupola.quantity}
											</div>
											<div className="summary-info">
												<aside className="summary-info-right">{cupola?.totalPrice != null && cupola?.totalPrice != undefined && <PriceDisplay value={String(cupola.totalPrice)} />}</aside>
											</div>
										</div>
									))}
							</>
						) : (
							<>
								<div className="summary-row d-flex justify-content-between repeat-loop">
									<div className="summary-label">
										<span className="summary-label-title">Cupola</span>
										{" - "}
										<span className="dark-span">NA</span>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			)}
		</>
	);
};
